import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Layout, Space, theme } from 'antd';
import { ModalContext } from '../../../shared/context/ModalContext';
import { modalReducer } from './modalReducer';
import { auth } from '../../../firestoreConfig';

import logo from '../../../assets/images/logo.svg';
import LayoutHeader from './LayoutHeader';
import LayoutMenu from './LayoutMenu';
import LayoutModal from './LayoutModal';

import './styles.css';

const { Content, Sider } = Layout;

export default function Index(props) {
    const [modalState, modalDispatch] = React.useReducer(modalReducer, modalReducer());
    const [collapsed, setCollapsed] = useState(false);
    const { token: { colorBgContainer } } = theme.useToken();

    const modalContextConfig = {
        confirm: (message, onOk, onCancel, okText, cancelText) => modalDispatch({ type: 'CONFIRM', message, onOk, onCancel, okText, cancelText }),
        success: (message, onOk = null) => modalDispatch({ type: 'SUCCESS', message, onOk }),
        warning: (message, onOk = null) => modalDispatch({ type: 'WARNING', message, onOk }),
        info: (message, onOk = null) => modalDispatch({ type: 'INFO', message, onOk }),
        error: (message, onOk = null) => modalDispatch({ type: 'ERROR', message, onOk })
    };

    useEffect(() => {

    }, []);

    const onSignOut = () => {
        auth.signOut().then(() => {

        }).catch((error) => {
            console.log(error);
        });
    };

    if (!auth.currentUser)
        return <Navigate to='/login' />

    return (
        <ModalContext.Provider value={modalContextConfig}>
            <Layout id="component-layout">
                <Sider collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} width={230}>
                    <div className="logo">
                        <Space >
                            <img src={logo} alt='logo' />
                            {
                                !collapsed ? <span className="title-app">JM Cartem</span> : null
                            }
                        </Space>
                    </div>
                    <LayoutMenu />
                </Sider>
                <Layout>
                    <LayoutHeader onSignOut={onSignOut} />
                    <Content style={{ padding: 30, background: colorBgContainer }}>
                        <div className="site-layout-content">
                            <Outlet />
                        </div>
                        <LayoutModal
                            state={modalState}
                            dispatch={modalDispatch}
                        />
                    </Content>
                </Layout>
            </Layout>
        </ModalContext.Provider>
    );
}